/* eslint-disable */
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';

import bubble_bg from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-pic2.png';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import img1 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-num1.png';
import img2 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-num2.png';
import img3 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-num3.png';
import img4 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-num4.png';
import img5 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-num5.png';
import rightArrow from '../../../../../../assets/cybersecurity2026/topic1230pm/section4-pic3.png';

import pic1 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-img1.png';
import pic2 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-img2.png';
import pic3 from '../../../../../../assets/cybersecurity2026/topic1230pm/section3-img3.png';

import ArrowImg from '../../../../../../assets/cybersecurity2026/finger.gif';

interface ISection3Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const updateComponentState = useUpdateComponentState();

  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );

  // 添加状态来跟踪当前显示的数据索引
  const [currentDataIndex, setCurrentDataIndex] = useState(0);
  // 添加状态来跟踪是否完成了所有切换
  const [hasCompletedCycle, setHasCompletedCycle] = useState(false);

  // 添加状态来控制两个列表的可见项数量
  const [visibleL2Items, setVisibleL2Items] = useState(1);
  const [visibleL3Items, setVisibleL3Items] = useState(1);
  const [showArrowGif, setShowArrowGif] = useState(true);
  const [showArrowGifPart3, setShowArrowGifPart3] = useState(true);

  // 处理l2Lists第一行的点击事件
  const handleL2FirstItemClick = () => {
    setShowArrowGif(false);
    if (visibleL2Items === 1 && paragraphsSettings?.l2Lists?.length) {
      let count = 1;
      const timer = setInterval(() => {
        count++;
        setVisibleL2Items(count);
        if (count >= paragraphsSettings.l2Lists.length) {
          clearInterval(timer);
          // 展示完成后调用updateComponentState
          updateComponentState(
            p_course,
            p_topic,
            ID,
            'cybersecurity2026-topic1230pm-section3-2'
          );
        }
      }, 500);
    }
  };

  // 处理l3Lists第一行的点击事件
  const handleL3FirstItemClick = () => {
    setShowArrowGifPart3(false);
    if (visibleL3Items === 1 && paragraphsSettings?.l3Lists?.length) {
      let count = 1;
      const timer = setInterval(() => {
        count++;
        setVisibleL3Items(count);
        if (count >= paragraphsSettings.l3Lists.length) {
          clearInterval(timer);
          // 展示完成后调用updateComponentState
          updateComponentState(
            p_course,
            p_topic,
            ID,
            'cybersecurity2026-topic1230pm-section3-3'
          );
        }
      }, 500);
    }
  };

  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: '-50px',
  });

  const numMap: any = {
    0: img1,
    1: img2,
    2: img3,
    3: img4,
    4: img5,
  };

  React.useEffect(() => {
    if (isVisible) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section3-1'
      );
    }
  }, [p_course, p_topic, isVisible]);

  React.useEffect(() => {
    if (hasCompletedCycle) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section3-4'
      );
    }
  }, [p_course, p_topic, hasCompletedCycle]);

  return (
    <div className="topic-section-3">
      {/* part1 */}
      <div
        className="phishing-fake-attack"
        ref={targetRef}
        id="cybersecurity2026-topic1230pm-section3-1"
      >
        <div className="title-container">
          <CTitle title={paragraphsSettings?.header} />
        </div>
        {isVisible && (
          <div className="dialogue-text">
            <div className="dialogue-left text-focus-in">
              {paragraphsSettings.l1Desc1}
            </div>
            <div className="dialogue-right text-focus-in">
              {paragraphsSettings.l1Desc2}
            </div>
          </div>
        )}
        <img className="dialogue-bg" src={bubble_bg} alt="" />
      </div>
      {/* part2 */}
      <div
        className="phishing-fake-attack-example"
        id="cybersecurity2026-topic1230pm-section3-2"
      >
        {showArrowGif && <img className="arrow-gif" src={ArrowImg} alt="" />}
        <div className="left-con">
          <div className="left-con-pic">{paragraphsSettings?.l2Tips}</div>
        </div>
        <div className="right-con">
          {paragraphsSettings?.l2Lists?.map(
            (item: { title: string; con: string }, index: string) => {
              const idx = parseInt(index);
              const isVisible = idx < visibleL2Items;
              return (
                <div
                  className={`right-con-item right-con-item-${index} ${
                    isVisible ? 'visible' : ''
                  }`}
                  key={item.title}
                  onClick={idx === 0 ? handleL2FirstItemClick : undefined}
                  style={{
                    cursor: idx === 0 ? 'pointer' : 'default',
                  }}
                >
                  <div className="title-style">{item.title}</div>
                  <div>{item.con}</div>
                </div>
              );
            }
          )}
        </div>
      </div>
      {/* part3 */}
      <div
        className="distinguish-authenticity"
        id="cybersecurity2026-topic1230pm-section3-3"
      >
        <div className="distinguish-authenticity-left">
          {showArrowGifPart3 && (
            <img className="arrow-gif" src={ArrowImg} alt="" />
          )}
          <div className="triangle-container">
            <span className="triangle"></span> {paragraphsSettings.l3Tips}
          </div>
          {paragraphsSettings?.l3Lists?.map((item: any, index: string) => {
            const idx = parseInt(index);
            const isVisible = idx < visibleL3Items;
            return (
              <div
                className={`right-con-item ${isVisible ? 'visible' : ''}`}
                key={index}
                onClick={idx === 0 ? handleL3FirstItemClick : undefined}
                style={{
                  cursor: idx === 0 ? 'pointer' : 'default',
                }}
              >
                <img src={numMap[index]} alt="" />
                <div className="text">{item.text}</div>
              </div>
            );
          })}
        </div>
        <div className="distinguish-authenticity-right"></div>
      </div>

      {/* part4 */}
      <div
        className="distinguish-authenticity-example"
        id="cybersecurity2026-topic1230pm-section3-4"
      >
        <div className="top">
          <div className="top-text-container">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  currentDataIndex === 0
                    ? paragraphsSettings.l4Text1
                    : paragraphsSettings.l4Text2,
              }}
            ></div>
            <img
              className="arrow-right"
              src={rightArrow}
              alt=""
              onClick={() => {
                const newIndex = currentDataIndex === 0 ? 1 : 0;
                setCurrentDataIndex(newIndex);
                if (newIndex === 0 && currentDataIndex === 1) {
                  setHasCompletedCycle(true);
                }
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
          {!hasCompletedCycle && (
            <img className="arrow-gif" src={ArrowImg} alt="" />
          )}
        </div>
        <div className="down">
          {currentDataIndex === 0 ? (
            <>
              <img className="pic1" src={pic1} alt="" />
              <img className="pic2" src={pic2} alt="" />
            </>
          ) : (
            <img className="pic3" src={pic3} alt="" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Section1;
